// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_g4-2";
export var aiChatCartContainerExit = "_g4-4";
export var aiChatContainerLarge = "_g4-0";
export var aiChatContainerSmall = "_g4-1";
export var aiChatIcon = "_g4-6";
export var slideInFromRight = "_g4-3";
export var slideOutToRight = "_g4-5";